<div class="munily-reservation-review-card">
  <!-- Header: avatar + nombre -->
  <div class="munily-reservation-review-card__header">
    <common-avatar
      size="medium"
      [imageUrl]="data?.avatarUrl"
      [initials]="data?.avatarInitials || ''"
      [alt]="data?.userName || ''"
    ></common-avatar>
    <div class="munily-reservation-review-card__header-labels">
      <span class="munily-reservation-review-card__username">{{ data?.userName }}</span>
    </div>
  </div>

  <!-- Review container -->
  <div class="munily-reservation-review-card__review">
    <!-- Info: unidad + fecha -->
    <div class="munily-reservation-review-card__info">
      <span *ngIf="data?.unitName" class="munily-reservation-review-card__unit">
        {{ data?.unitName }}
      </span>
      <span *ngIf="data?.date" class="munily-reservation-review-card__date">
        {{ data?.date }}
      </span>
    </div>

    <!-- Descripción -->
    <p *ngIf="data?.description" class="munily-reservation-review-card__description">
      {{ data?.description }}
    </p>
  </div>
</div>
